'use client'

import { useCallback, useMemo } from 'react'

import ExpandablePanel from 'shared/ui/ExpandablePanel'
import { RadioItem } from 'shared/ui/RadioGroup'

import {
  mapPriceFiltersToQuery,
  parsePriceString,
  PRICE_FILTER_OPTIONS,
  PriceFilterValidator,
  PriceType
} from '../utils'

import PriceMinMaxInput from './PriceMinMaxInput'
import { FiltersRadioGroup } from './styles'

interface PriceFilterMobileProps {
  value: string | null
  onChange: (path: string, value: string | null) => void
}

const PriceFilterMobile = ({ onChange, value }: PriceFilterMobileProps) => {
  const prices = useMemo(() => {
    if (!value) return { min: '', max: '' }

    return parsePriceString(value)
  }, [value])

  const handlePriceSetSelect = (range: string) => {
    const [min, max] = range.split('|')
    const newPrice = mapPriceFiltersToQuery({ min, max })

    onChange('price', newPrice)
  }

  const handlePriceChange = useCallback(
    ({ min, max }: PriceType) => {
      const newPrice = mapPriceFiltersToQuery({ min, max })

      onChange('price', newPrice)
    },
    [onChange]
  )

  const selectedPrice = useMemo(() => {
    if (PriceFilterValidator.isNoSelected(prices)) return '|'
    if (PriceFilterValidator.isUnder10(prices)) return '|10'
    if (PriceFilterValidator.isBetween10_20(prices)) return '10|20'
    if (PriceFilterValidator.isBetween20_50(prices)) return '20|50'
    if (PriceFilterValidator.isAbove50(prices)) return '50|'

    return null
  }, [prices])

  return (
    <ExpandablePanel title={'Cena'} id='price-filter-mobile'>
      <FiltersRadioGroup
        name='mobile-prices'
        selectedValue={selectedPrice}
        onChange={handlePriceSetSelect}
      >
        {PRICE_FILTER_OPTIONS.map(option => (
          <RadioItem key={option.label} value={option.min + '|' + option.max}>
            {option.label}
          </RadioItem>
        ))}
      </FiltersRadioGroup>

      <PriceMinMaxInput
        onChange={handlePriceChange}
        minValue={prices.min}
        maxValue={prices.max}
      />
    </ExpandablePanel>
  )
}

export default PriceFilterMobile
